module.exports = __webpack_public_path__ + "static/media/0_2019_05_03-2.73386f31.jpg";